class Market {

  /**
   * Delegate Function() As String
   */
  _headerFooterTemplate = null;
  /**
   * Gets header footer template of page.
   */
  get HeaderFooterTemplate() {
    return this._headerFooterTemplate();
  }

  /**
   * Delegate Function() As String
   */
  _currentCulture = null;
  /**
   * Gets culture of the current page.
   */
  get CurrentCulture() {
    return this._currentCulture();
  }

  /**
   * Market
   */
  static s_CN = null;
  /**
   * Supports zh-CN only.
   */
  static get CN() {
    if (Market.s_CN == null) {
      let mkt = new Market();
      mkt._headerFooterTemplate = () => "zh-CN"
      mkt._currentCulture = () => "zh-CN"
      Market.s_CN = mkt
    }
    return Market.s_CN
  }

  /**
   * Market
   */
  static s_JP = null;
  /**
   * Supports ja-JP only.
   */
  static get JP() {
    if (Market.s_JP == null) {
      let mkt = new Market();
      mkt._headerFooterTemplate = () => "Invariant"
      mkt._currentCulture = () => "ja-JP"
      Market.s_JP = mkt
    }
    return Market.s_JP
  }

  /**
   * Market
   */
  static s_US;
  /**
   * Supports en-US.
   */
  static get US() {
    if (Market.s_US == null) {
      let mkt = new Market();
      mkt._headerFooterTemplate = () => "Invariant"
      mkt._currentCulture = () => "en-US"
      Market.s_US = mkt
    }
    return Market.s_US
  }

  /**
   * Market
   */
  static s_KR;
  /**
   * Supports ko-KR.
   */
  static get KR() {
    if (Market.s_KR == null) {
      let mkt = new Market();
      mkt._headerFooterTemplate = () => "ko-KR"
      mkt._currentCulture = () => "ko-KR"
      Market.s_KR = mkt
    }
    return Market.s_KR
  }

  /**
   * The value of this property is decided at compile-time.
   * Returns: Market
   */
  static get CurrentMarket() {
    // Warning: Do not commit any changes to this method.
    // f2ef743f-cbdd-40fe-88cd-b9733c7a10ba
        return Market.US
  }

}

export default Market
